import React, {useState, useEffect} from 'react'
import {Modal} from 'react-bootstrap'
import {useCreateGatewayProviderMutation} from '../../../../../services/cellcast'
import {toast} from 'react-toastify'
import Select from 'react-select'
import {
  GATEWAY_NAME_OPTIONS,
  DB_OPTIONS,
  NUMBER_TYPE,
} from '../../../../Utils/Constant/ConstantForWebsite'
import {useSelector} from 'react-redux'
import {useGetGatewayConfigsQuery} from '../../../../../services/cellcast'

const CreateGatewayManagementList = ({show, handleClose, refetch}: any) => {
  const [createGatewayProvider] = useCreateGatewayProviderMutation()
  const [error, setError] = useState<any>({})
  const paymentGatewayList = useSelector((state: any) => state?.paymentGateway?.GatewayManagement)
  const {data: gatewayConfigs} = useGetGatewayConfigsQuery({page: 1, size: 100})

  const [paymentMethod, setPaymentMethod] = useState({
    gatewayName: '',
    DB: '',
    type: '',
    status: 'offline',
    DNmonthly: '',
    DNyearly: '',
    price_per_part: 0,
    gatewayConfigId: '', // Add gateway config relation
  })

  useEffect(() => {
    if (!show) {
      // Reset form when modal is closed
      setPaymentMethod({
        gatewayName: '',
        DB: '',
        type: '',
        status: 'offline',
        DNmonthly: '',
        DNyearly: '',
        price_per_part: 0,
        gatewayConfigId: '',
      })
      setError({})
    }
  }, [show])

  const handleSubmit = async () => {
    if (Object.keys(Validation(paymentMethod))?.length == 0) {
      try {
        // Prepare the data to send, including gatewayConfigId if selected
        const dataToSend = {
          ...paymentMethod,
          gatewayConfigId: paymentMethod.gatewayConfigId || undefined,
        }

        const result: any = await createGatewayProvider(dataToSend).unwrap()
        toast.success(result?.message || 'Gateway created successfully!')
        handleClose()
        refetch()
      } catch (error: any) {
        toast.error(error?.data?.message || 'Failed to create gateway')
      }
    }
  }

  const Validation = (val: any) => {
    const errors: any = {}

    if (!val?.gatewayName) {
      errors.gatewayName = 'Please enter Gateway Name'
    }
    if (!val?.DB) {
      errors.DB = 'Please enter Account Name'
    }
    if (!val?.DNmonthly) {
      errors.DNmonthly = 'Please enter monthly price'
    }
    if (!val?.DNyearly) {
      errors.DNyearly = 'Please enter yearly price'
    }
    if (
      val?.price_per_part === '' ||
      val?.price_per_part === null ||
      val?.price_per_part === undefined
    ) {
      errors.price_per_part = 'Please enter Price Per Part'
    }

    setError({...errors})

    return errors
  }

  return (
    <>
      <Modal
        id='kt_modal_create_app'
        tabIndex={1}
        aria-hidden='true'
        dialogClassName='modal-dialog-centered mw-700px'
        className='vh-100'
        show={show}
        onHide={handleClose}
      >
        <div className='modal-header'>
          <h2>Create Gateway Management</h2>
        </div>
        <div className='modal-body p-10 pb-15'>
          <div className='row justify-content-center m-2 p-3'>
            <div>
              <div className='row mb-5'>
                <div className='col-6'>
                  <label className=' col-form-label required fw-bold fs-6'>Gateway Name</label>
                  <Select
                    name='gatewayName'
                    value={
                      GATEWAY_NAME_OPTIONS.find(
                        (option) => option.value === paymentMethod?.gatewayName
                      ) || null
                    }
                    onChange={(selectedOption: any) =>
                      setPaymentMethod({...paymentMethod, gatewayName: selectedOption?.value || ''})
                    }
                    options={GATEWAY_NAME_OPTIONS.filter(
                      (option) =>
                        !paymentGatewayList?.some((item: any) => item.gatewayName === option.value)
                    )}
                    className='form-control-solid'
                    placeholder='Select Gateway Name'
                  />
                  {error?.gatewayName && <span className='text-danger'>{error?.gatewayName}</span>}
                </div>
                <div className='col-6'>
                  <label className=' col-form-label required fw-bold fs-6'>DB</label>
                  <Select
                    name='DB'
                    value={DB_OPTIONS.find((option) => option.value === paymentMethod?.DB) || null}
                    onChange={(selectedOption: any) =>
                      setPaymentMethod({...paymentMethod, DB: selectedOption?.value || ''})
                    }
                    options={DB_OPTIONS}
                    className='form-control-solid'
                    placeholder='Select DB'
                  />
                  {error?.DB && <span className='text-danger'>{error?.DB}</span>}
                </div>
              </div>

              <div className='row mb-5'>
                <div className='col-12'>
                  <label className='col-form-label fw-bold fs-6'>Gateway Config</label>
                  <Select
                    name='gatewayConfigId'
                    value={
                      gatewayConfigs?.data?.items?.find(
                        (config: any) => config._id === paymentMethod?.gatewayConfigId
                      )
                        ? {
                            value: gatewayConfigs?.data?.items?.find(
                              (config: any) => config._id === paymentMethod?.gatewayConfigId
                            )?._id,
                            label: gatewayConfigs?.data?.items?.find(
                              (config: any) => config._id === paymentMethod?.gatewayConfigId
                            )?.name,
                          }
                        : null
                    }
                    onChange={(selectedOption: any) =>
                      setPaymentMethod({
                        ...paymentMethod,
                        gatewayConfigId: selectedOption?.value || '',
                      })
                    }
                    options={
                      gatewayConfigs?.data?.items?.map((config: any) => ({
                        value: config._id,
                        label: config.name + ' - ' + config.provider + ' - ',
                      })) || []
                    }
                    className='form-control-solid'
                    placeholder='Select Gateway Config'
                  />
                </div>
              </div>

              <div className='row justify-content-center m-2 p-3 '>
                <div className='col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12'>
                  <input
                    type='radio'
                    className='btn-check'
                    checked={paymentMethod?.type === NUMBER_TYPE.SMS}
                    id='quick_sms_radio'
                    onChange={() => {
                      setPaymentMethod({...paymentMethod, type: NUMBER_TYPE.SMS})
                    }}
                  />
                  <label
                    className='btn btn-outline btn-outline-dashed btn-outline-default w-100 p-4'
                    htmlFor='quick_sms_radio'
                  >
                    <span className='fw-500 fs-5'>SMS</span>
                  </label>
                </div>
                <div className='col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12'>
                  <input
                    type='radio'
                    className='btn-check'
                    checked={paymentMethod?.type === NUMBER_TYPE.MMS}
                    id='quick_mms_radio'
                    onChange={() => {
                      setPaymentMethod({...paymentMethod, type: NUMBER_TYPE.MMS})
                    }}
                  />
                  <label
                    className='btn btn-outline btn-outline-dashed btn-outline-default w-100 p-4'
                    htmlFor='quick_mms_radio'
                  >
                    <span className='fw-500 fs-5'>MMS</span>
                  </label>
                </div>
              </div>
              <div className='row justify-content-center py-3 '>
                <div>
                  <label className=' col-form-label required fw-bold fs-6'>Price Per Part</label>
                  <input
                    value={paymentMethod?.price_per_part}
                    onChange={(e: any) =>
                      setPaymentMethod({...paymentMethod, price_per_part: e.target.value})
                    }
                    className='form-control-solid form-control'
                    placeholder='Price Per Part'
                    type='number'
                  />
                  {error?.price_per_part && (
                    <span className='text-danger'>{error?.price_per_part}</span>
                  )}
                </div>
                <div>
                  <label className=' col-form-label required fw-bold fs-6'>Monthly Cost</label>
                  <input
                    value={paymentMethod?.DNmonthly}
                    onChange={(e: any) =>
                      setPaymentMethod({...paymentMethod, DNmonthly: e.target.value})
                    }
                    className='form-control-solid form-control'
                    placeholder='Monthly Cost'
                    type='number'
                  />
                  {error?.DNmonthly && <span className='text-danger'>{error?.DNmonthly}</span>}
                </div>
                <div>
                  <label className=' col-form-label required fw-bold fs-6'>Yearly Cost</label>
                  <input
                    value={paymentMethod?.DNyearly}
                    onChange={(e: any) =>
                      setPaymentMethod({...paymentMethod, DNyearly: e.target.value})
                    }
                    className='form-control-solid form-control'
                    placeholder='Yearly Cost'
                    type='number'
                  />
                  {error?.DNyearly && <span className='text-danger'>{error?.DNyearly}</span>}
                </div>
              </div>
            </div>

            <div>
              <div className='col-lg-8 d-flex align-items-center mt-5'>
                <div className='form-check form-check-solid form-switch fv-row'>
                  <input
                    className='form-check-input w-45px h-30px'
                    type='checkbox'
                    id='allowmarketing'
                    checked={paymentMethod.status == 'online'}
                    onChange={() => {
                      let val = paymentMethod.status == 'online' ? 'offline' : 'online'
                      setPaymentMethod({...paymentMethod, status: val})
                    }}
                  />
                  <label className='form-check-label'>Online Status</label>
                </div>
              </div>
            </div>
          </div>
          <div className='d-flex flex-center mt-5'>
            <div id='kt_drawer_chat_close'>
              <button
                type='button'
                onClick={handleClose}
                className='btn btn-md gray_bg_purple me-2'
              >
                Cancel
              </button>
            </div>
            <button
              type='submit'
              className='btn btn-md btn-primary fw-500   w-100px p-3 border border-primary'
              onClick={handleSubmit}
            >
              <span className='indicator-label'>Submit</span>
            </button>
          </div>
        </div>
      </Modal>
    </>
  )
}

export default CreateGatewayManagementList
